const name = 'module-management';

export const GET_MODULES_LIST_REQUEST = `${name}/GET_MODULES_LIST_REQUEST`;
export const GET_MODULES_LIST_SUCCESS = `${name}/GET_MODULES_LIST_SUCCESS`;
export const GET_MODULES_LIST_FAILURE = `${name}/GET_MODULES_LIST_FAILURE`;

export const INSTALL_MODULE_REQUEST = `${name}/INSTALL_MODULE_REQUEST`;
export const INSTALL_MODULE_SUCCESS = `${name}/INSTALL_MODULE_SUCCESS`;
export const INSTALL_MODULE_FAILURE = `${name}/INSTALL_MODULE_FAILURE`;

export const UNINSTALL_MODULE_REQUEST = `${name}/UNINSTALL_MODULE_REQUEST`;
export const UNINSTALL_MODULE_SUCCESS = `${name}/UNINSTALL_MODULE_SUCCESS`;
export const UNINSTALL_MODULE_FAILURE = `${name}/UNINSTALL_MODULE_FAILURE`;

export default name;
